import { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AppContext } from './context'
import UiSpinner from './ui_spinner';
import UiButton3 from './ui_button3';
import UiInput1 from './ui_input1';
import UiButton1 from './ui_button1';
import moment from 'moment';
import BrandAuthStatus from './brand_auth_status';
import UiTooltip from './ui_tooltip';

const BrandAuth = () => {

	const navigate = useNavigate()
	const { id } = useParams()
	const {
		setPopupSidebarType,
		offCanvas,
		setSideBarTitle,
		setToDeleteMarketplace,
		hh,
		ww,
		neonUser,
		getMarketPlace,
		marketplaceList,
		reloadAuthorizedMarketplaceList, setReloadAuthorizedMarketplaceList,
		updateChecklist,
		brand, setBrand,
		userOwnsBrand,
		clientAuthList,
		getAgencyClients,
		adsIssueList,
		getAdsAuthStatus,
		allAdsProfileIds,
		getBrands,
		fetchDataV2,
		adsProfileIdsLoaded
	} = useContext(AppContext)

	const [profiles, setProfiles] = useState([])
	const [selectedMarketPlace, setSelectedMarketPlace] = useState("")
	const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"))
	const [errorList, setErrorList] = useState([])
	const [generalMessage, setGeneralMessage] = useState([])
	const [authorizedMarketplaceList, setAuthorizedMarketplaceList] = useState([])
	const [tableLoading, setTableLoading] = useState(false)
	const [addLoading, setAddLoading] = useState(false)
	const [agencyLoaded, setAgencyLoaded] = useState(false)

	const getBrandsLocal = async () => {
		if (!isFinite(id)) {
			navigate("/brand", { replace: true })
			return
		}

		let query = "GET_BRANDS_LOCAL", params = [id, neonUser.agency.agency_id];

		if (neonUser.role == 'admin') {
			query = 'GET_BRANDS_LOCAL_ADMIN';
			params = [id]
		}

		let resp = await fetchDataV2(query, params, "/neon-query-v2")

		if (resp.length == 0) return navigate("/brand")

		setBrand(resp[0])
	}

	const goBack = (e) => {
		e.preventDefault()
		navigate("/brand")
	}

	const addMarketPlace = async () => {
		setGeneralMessage("")
		setErrorList([])

		let valid = true;
		let errs = []

		if (["", false, undefined, null].includes(selectedDate)) {
			errs.push("selectedDate")
			valid = false
		}
		if (["", false, undefined, null].includes(selectedMarketPlace)) {
			errs.push("selectedMarketPlace")
			valid = false
		}

		if (!valid) {
			setErrorList(errs)
			setGeneralMessage("You must select a country")
			return false
		}

		let query = "INSERT_BRAND_MARKETPLACE", params = [
			brand.brand_entity_id,
			selectedMarketPlace,
			moment().format("YYYY-MM-DD"),
			neonUser.agency_id
		]

		let resp = await fetchDataV2(query, params, "/neon-query-v2")

		if (!resp) {
			setGeneralMessage("error! please try again.")
			return false
		}

		getAuthorizedMarketplace()
		setGeneralMessage("marketplace added.")
		setSelectedDate("")
		setSelectedMarketPlace("")
		updateChecklist('seller_account', neonUser.user_id)

		return resp
	}

	const getAuthorizedMarketplace = async () => {
		setAuthorizedMarketplaceList([])
		setTableLoading(true)

		let query1 = "GET_AUTHORIZED_MARKETPLACE_1", params1 = [neonUser.agency_id, brand.brand_entity_id]
		if (neonUser.role == "admin") {
			query1 = "GET_AUTHORIZED_MARKETPLACE_1_ADMIN";
			params1 = [brand.brand_entity_id]
		}

		let query2 = "GET_AUTHORIZED_MARKETPLACE_2", params2 = [neonUser.user.agency_id]
		let query3 = "GET_AUTHORIZED_MARKETPLACE_3", params3 = [brand.brand_entity_id]
		let query4 = "GET_AUTHORIZED_MARKETPLACE_4", params4 = [brand.brand_entity_id]

		let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
		let agency = await fetchDataV2(query2, params2, "/neon-query-v2")
		let company_list = await fetchDataV2(query3, params3, "/neon-market-v2")
		let ppc_list = await fetchDataV2(query4, params4, "/neon-query-v2")

		let ppc_profiles = []

		if (ppc_list.length > 0) {
			ppc_list = ppc_list.map(x => ({
				...x,
				...marketplaceList.filter(xx => xx.id == Number(x.marketplace_id))[0] || {}
			}))

			let query5 = "GET_AUTHORIZED_MARKETPLACE_5", params5 = [ppc_list.map(x => x.client_profile_id)]
			ppc_profiles = await fetchDataV2(query5, params5, '/neon-market-v2');
		}

		resp = resp.map(x => ({
			...x,
			brand,
			marketplace: marketplaceList.filter(xx => xx.id == Number(x.marketplace_id))[0],
			agency: agency[0] || {},
		}))

		resp = resp.map(x => ({
			...x,
			company: company_list.filter(xx => xx.marketplaceId == x.marketplace.marketplaceid)[0],
			ppc_profiles: ppc_profiles
				.map(xx => ({
					...xx,
					marketplace_profile: ppc_list.filter(xxx => xxx.client_profile_id == xx.profile_id)[0] || null
				}))
				.filter(xx => xx.marketplace_profile.marketplaceid == x.marketplace.marketplaceid),
		}))

		resp = resp.map(x => {
			// console.log(x)
			return {
				...x,
				auth_error: x?.company?.id
					? clientAuthList.filter(xx => !xx.status).map(xx => xx.client_info_id).includes(Number(x.company.client_id))
					: false
			}
		})

		setAuthorizedMarketplaceList(resp)
		// console.log(resp)
		setTableLoading(false)
		return
	}

	const addMarketPlaceAndRedirect = async (x) => {
		setAddLoading(true)
		let resp = await addMarketPlace();
		if (!resp) return setAddLoading(false);
		if (resp.length > 0) {
			navigate("/brand/auth/view/" + resp[0].id);
			return
		}
	}

	const getProfiles = async (brand_entity_id) => {
		let query = "GET_PROFILES", params = [brand_entity_id]
		let resp = await fetchDataV2(query, params, "/neon-market-v2")
		setProfiles(resp)
		return
	}

	const deleteMarketPlace = (x) => {
		setPopupSidebarType("delete_marketplace")
		setSideBarTitle("Delete Marketplace")
		offCanvas.show()
		setToDeleteMarketplace(x.id)
	}

	useEffect(() => {
		if (!!neonUser.user_id) getBrandsLocal()
	}, [neonUser])

	useEffect(() => {
		if (!!brand.id) getMarketPlace()
	}, [brand])

	useEffect(() => {
		if (
			marketplaceList.length > 0
			&& !!neonUser?.user_id
			&& authorizedMarketplaceList.length == 0
			&& !!brand.id
		) {
			getAuthorizedMarketplace()
		}
	}, [marketplaceList, neonUser, brand])

	useEffect(() => {
		if (authorizedMarketplaceList.length > 0) {
			let list = authorizedMarketplaceList.map(x => x.ppc_profiles).flat(Infinity).map(x => ({ profile: x }))
			getAdsAuthStatus(list, 'brand_auth')
		}
	}, [authorizedMarketplaceList])

	useEffect(() => {
		if (reloadAuthorizedMarketplaceList) {
			getAuthorizedMarketplace()
			setReloadAuthorizedMarketplaceList(false)
		}
	}, [reloadAuthorizedMarketplaceList])

	useEffect(() => {
		if (brand.created) setSelectedDate(moment(brand.created).format("YYYY-MM-DD"))
		if (brand.brand_entity_id && neonUser) getProfiles(brand.brand_entity_id)
		if (neonUser.user_id && brand.brand_entity_id) userOwnsBrand(neonUser, brand)
	}, [brand, neonUser])

	useEffect(() => {
		if (neonUser?.user_id && marketplaceList.length > 0) {
			(async () => {
				await getAgencyClients()
				setAgencyLoaded(true)
			})()
		}
	}, [neonUser, marketplaceList])

	useEffect(() => {
		if (agencyLoaded) {
			(async () => {
				await getBrands()
			})()
		}
	}, [agencyLoaded, adsProfileIdsLoaded])

	useEffect(() => {
		setAuthorizedMarketplaceList([])
		return () => { setAuthorizedMarketplaceList([]) }
	}, [])

	if (!brand?.id) return (
		<div className="d-flex justify-content-center" style={{ height: hh - 80 }}>
			<UiSpinner />
		</div>
	)

	return (
		<div style={{ maxWidth: 1600 }}>
			<div className={"d-flex flex-column gap-2 " + (ww < 400 ? "px-2 pt-4" : "p-4")}>
				<div className="d-flex gap-1">
					<UiButton3 submit={goBack} />
					<p className="mb-0 align-self-center fs-4">Brand/Account {">"} {brand.brand}</p>
				</div>

				<BrandAuthStatus marketLoad={tableLoading} type="market" marketplace_list={authorizedMarketplaceList} client_ids={authorizedMarketplaceList.filter(x => !!x.company).map(x => x.company.client_id)} />

				<div className="container1 ">
					{brand.id && <p className='poppins fw-bold text-capitalize'>Marketplace List</p>}
					{generalMessage != "" ? <span className={"poppins mb-1" + (errorList.length > 0 ? 'text-danger' : 'text-success')}>{generalMessage}</span> : null}
					<div className="table-responsive">
						<table className="brand-table">
							<thead>
								<tr>
									<th>Country</th>
									<th className="middle-row-th">Date Created</th>
									<th className="middle-row-th text-capitalize">Account Status</th>
									{brand?.ads_management && brand?.ads_management.includes('ppc') && <th className="middle-row-th">Ads Status</th>}
									<th className="middle-row-th">Action</th>
								</tr>
							</thead>
							<tbody>
								{tableLoading && authorizedMarketplaceList.length == 0 && (
									<tr>
										<td colSpan={5}><UiSpinner /></td>
									</tr>
								)}
								{!tableLoading && authorizedMarketplaceList.length > 0 ?
									authorizedMarketplaceList.map((x, i) => (
										<tr key={x.id}>
											<td onClick={() => navigate("/brand/auth/view/" + x.id)} style={{ cursor: "pointer" }}>
												<span>{x.marketplace.country}</span>
											</td>
											<td onClick={() => navigate("/brand/auth/view/" + x.id)} className="middle-row-td">{moment(x.date_start).format("MMM DD, YYYY")}</td>

											<td onClick={() => navigate("/brand/auth/view/" + x.id)} className="middle-row-td">
												{x.auth_error ?
													<div className='text-danger d-flex gap-1 justify-content-center'>
														<span className='text-danger'>Issue</span>
														<UiTooltip title={`The previously authenticated ${x.brand.account_type == 'seller' ? "Seller" : "Vendor"} Central account is no longer connected. Immediate action required.`}>
															<i className="bi bi-info-circle-fill "></i>
														</UiTooltip>
													</div>
													: !x.company ?
														<div className='d-flex gap-1 justify-content-center'>
															<span className=''>Pending</span>
															<UiTooltip title={`Marketplace was created but there is no ${x.brand.account_type == 'seller' ? "Seller" : "Vendor"} Central account connected yet.`}>
																<i className="bi bi-info-circle-fill "></i>
															</UiTooltip>
														</div>
														:
														<span className='text-success'>Connected</span>
												}
											</td>

											{brand.ads_management && brand.ads_management.includes('ppc') &&
												<td onClick={() => navigate("/brand/auth/view/" + x.id)} className="middle-row-td">
													{x.ppc_profiles.map(xx => xx.profile_type == 'dsp' ? xx.advertiser_id : xx.profileId).filter(xx => !allAdsProfileIds.includes(xx)).length > 0 ?
														<UiTooltip title="One or more of your ads profiles has authentication issues. Immediate action required.">
															<span className='text-danger'>Issue <i className="bi bi-info-circle-fill "></i></span>
														</UiTooltip>
														: x.ppc_profiles.length > 0 ?
															<div className='d-flex gap-2 w-100 justify-content-center'>
																{x.ppc_profiles.filter(xx => xx.marketplace_profile.countrycode == x.marketplace.countrycode && xx.profile_active_status == true).length > 0 &&
																	<span className='text-success'>
																		{x.ppc_profiles.filter(xx => xx.marketplace_profile.countrycode == x.marketplace.countrycode && xx.profile_active_status == true).length} Active
																	</span>
																}
																{x.ppc_profiles.filter(xx => xx.marketplace_profile.countrycode == x.marketplace.countrycode && xx.profile_active_status == false).length > 0 &&
																	<span className='text-danger'>
																		{x.ppc_profiles.filter(xx => xx.marketplace_profile.countrycode == x.marketplace.countrycode && xx.profile_active_status == false).length} Inactive
																	</span>
																}
															</div>
															:
															"n/a"
													}
												</td>
											}
											<td className="middle-row-td">
												<div className="d-flex justify-content-evenly">
													<UiTooltip title="View">
														<div onClick={() => navigate("/brand/auth/view/" + x.id)} style={{ width: 20, height: 20 }}>
															<img src={"/src/view.png"} style={{ width: "100%" }} />
														</div>
													</UiTooltip>
													<UiTooltip title="Delete">
														<div onClick={() => deleteMarketPlace(x)} style={{ width: 20, height: 20 }}>
															<img src={"/src/delete.png"} style={{ width: "100%" }} />
														</div>
													</UiTooltip>
												</div>
											</td>
										</tr>
									))
									:
									!tableLoading &&
									<tr className="text-center">
										<td colSpan={6} className='poppins text-secondary'>Nothing to show...</td>
									</tr>
								}
								<tr>
									<td colSpan="6">
										{tableLoading ?
											<UiSpinner />
											:
											<div className="col-sm-12 col-md-6 w-100 p-2">
												<div className="d-flex gap-1 justify-content-between ">
													<div className="d-flex gap-3 ">
														<p className="poppins mb-0 fw-bold align-self-center">Country Select</p>
														<UiInput1
															field="marketplace"
															userChangeHandler={setSelectedMarketPlace}
															marketplace={marketplaceList.filter(x => !authorizedMarketplaceList.map(xx => Number(xx.marketplace_id)).includes(x.id))} />
													</div>
													<div style={{ width: 150 }} className="align-self-center">
														{addLoading ?
															<UiSpinner />
															:
															<UiButton1 text="ADD" submit={() => addMarketPlaceAndRedirect(selectedMarketPlace)} />
														}
													</div>
												</div>
											</div>
										}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	)
}

export default BrandAuth